// Sensei/common/schemas/collections/assignmentSubmissions.js
import { z } from "zod";

const AssignmentSubmissionSchema = z.object({
    _id: z.string().optional(),
    studentId: z.string(),
    courseId: z.string(),
    topicId: z.string(),
    scheduleId: z.string(),
    
    status: z.enum(['submitted', 'grading', 'approved', 'rejected']).default('submitted'),
    
    // The submitted files
    submissionFiles: z.array(z.object({
        fileName: z.string(),
        filePath: z.string(), // Relative path from UploadDownloadService
        fileType: z.string(),
    })).optional(),
    
    // Final results from AI review
    finalScore: z.number().optional().nullable(),
    feedback: z.string().optional().nullable(),
    
    // Timestamps
    submittedAt: z.coerce.date().optional(),
    gradedAt: z.coerce.date().optional().nullable(),
});

export default AssignmentSubmissionSchema;